import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-details-aams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-details-aams.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { AppControllerService } from "../../../../../app-controller.service";
import { ViewApplicationService } from "../../../view-application.service";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { ViewApplicationDetailsAamsConstants } from "./view-application-details-aams.constants";
import { LookupConstants } from "../../../../../shared/constants/lookup.constants";
import { AlertType } from "../../../../../shared/models/alert";
import { RecipientSelectService } from "../../../../../shared/components/recipient-select/shared/service/recipient-select.service";
import { DatePipe } from "@angular/common";
let ViewApplicationDetailsAamsComponent = class ViewApplicationDetailsAamsComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    viewApplicationService;
    route;
    recipientSelectService;
    datePipe;
    routerParamsService;
    appControllerService;
    changeDetectorRefs;
    detailsForm;
    advertisementsFormGroupName = ViewApplicationDetailsAamsConstants.ADVERTISEMENTS_FORM_GROUP_NAME;
    validationMessages = ViewApplicationDetailsAamsConstants.VALIDATION_MESSAGES;
    applicationDetailsFormGroupName = ViewApplicationDetailsAamsConstants.APPLICATION_DETAILS_FORM_GROUP_NAME;
    // FormControls
    descriptionFormControlName = ViewApplicationDetailsAamsConstants.DESCRIPTION_FORM_CONTROL_NAME;
    advertisementsFormControlName = ViewApplicationDetailsAamsConstants.ADVERTISEMENTS_FORM_CONTROL_NAME;
    isAdvertisementPermanentOrTemporaryFormControlName = ViewApplicationDetailsAamsConstants.IS_ADVERTISEMENT_PERMANENT_OR_TEMPORARY_FORM_CONTROL_NAME;
    applicationTypeFormControlName = ViewApplicationDetailsAamsConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    displayStartDateControlName = ViewApplicationDetailsAamsConstants.DISPLAY_START_DATE_FORM_CONTROL_NAME;
    displayEndDateControlName = ViewApplicationDetailsAamsConstants.DISPLAY_END_DATE_FORM_CONTROL_NAME;
    displayRemovalDateControlName = ViewApplicationDetailsAamsConstants.DISPLAY_REMOVAL_DATE_FORM_CONTROL_NAME;
    numberOfPostersControlName = ViewApplicationDetailsAamsConstants.NUMBER_OF_POSTERS_FORM_CONTROL_NAME;
    nameOfBusinessControlName = ViewApplicationDetailsAamsConstants.NAME_OF_BUSINESS_FORM_CONTROL_NAME;
    notifySignageRemovalPeriodControlName = ViewApplicationDetailsAamsConstants.NOTIFY_SIGNAGE_REMOVAL_PERIOD_FORM_CONTROL_NAME;
    positionOfTheDisplayControlName = ViewApplicationDetailsAamsConstants.POSITION_OF_DISPLAY_FORM_CONTROL_NAME;
    heightControlName = ViewApplicationDetailsAamsConstants.HEIGHT_FORM_CONTROL_NAME;
    widthControlName = ViewApplicationDetailsAamsConstants.WIDTH_FORM_CONTROL_NAME;
    depthControlName = ViewApplicationDetailsAamsConstants.DEPTH_FORM_CONTROL_NAME;
    materialControlName = ViewApplicationDetailsAamsConstants.MATERIAL_FORM_CONTROL_NAME;
    coloursControlName = ViewApplicationDetailsAamsConstants.COLOURS_FORM_CONTROL_NAME;
    frontalAreaControlName = ViewApplicationDetailsAamsConstants.FRONTAL_AREA_FORM_CONTROL_NAME;
    totalAreaControlName = ViewApplicationDetailsAamsConstants.TOTAL_AREA_FORM_CONTROL_NAME;
    signTypeControlName = ViewApplicationDetailsAamsConstants.SIGN_TYPE_FORM_CONTROL_NAME;
    weightControlName = ViewApplicationDetailsAamsConstants.WEIGHT_FORM_CONTROL_NAME;
    wattageControlName = ViewApplicationDetailsAamsConstants.WATTAGE_FORM_CONTROL_NAME;
    signContractorControlName = ViewApplicationDetailsAamsConstants.SIGN_CONTRACTOR_NAME_FORM_CONTROL_NAME;
    signContractorAddressControlName = ViewApplicationDetailsAamsConstants.SIGN_CONTRACTOR_ADDRESS_FORM_CONTROL_NAME;
    signContractorTelephoneControlName = ViewApplicationDetailsAamsConstants.SIGN_CONTRACTOR_TELEPHONE_FORM_CONTROL_NAME;
    forSaleControlName = ViewApplicationDetailsAamsConstants.FOR_SALE_FORM_CONTROL_NAME;
    onShowControlName = ViewApplicationDetailsAamsConstants.ON_SHOW_FORM_CONTROL_NAME;
    toLetControlName = ViewApplicationDetailsAamsConstants.TO_LET_FORM_CONTROL_NAME;
    soldControlName = ViewApplicationDetailsAamsConstants.SOLD_FORM_CONTROL_NAME;
    OtherControlName = ViewApplicationDetailsAamsConstants.OTHER_FORM_CONTROL_NAME;
    constructionBoardSignControlName = ViewApplicationDetailsAamsConstants.CONSTRUCTION_BOARD_SIGN_FORM_CONTROL_NAME;
    groundSignControlName = ViewApplicationDetailsAamsConstants.GROUND_SIGN_FORM_CONTROL_NAME;
    flagControlName = ViewApplicationDetailsAamsConstants.FLAG_FORM_CONTROL_NAME;
    sandwichBoardControlName = ViewApplicationDetailsAamsConstants.SANDWICH_BOARD_FORM_CONTROL_NAME;
    pylonControlName = ViewApplicationDetailsAamsConstants.PYLON_FORM_CONTROL_NAME;
    wallSignControlName = ViewApplicationDetailsAamsConstants.WALL_SIGN_FORM_CONTROL_NAME;
    billBoardControlName = ViewApplicationDetailsAamsConstants.BILLBOARD_FORM_CONTROL_NAME;
    buildingAttachmentControlName = ViewApplicationDetailsAamsConstants.BUILDING_ATTACHMENT_FORM_CONTROL_NAME;
    projectingWallControlName = ViewApplicationDetailsAamsConstants.PROJECTING_WALL_SIGN_FORM_CONTROL_NAME;
    wallPaintedControlName = ViewApplicationDetailsAamsConstants.WALL_PAINTED_FORM_CONTROL_NAME;
    roofSignControlName = ViewApplicationDetailsAamsConstants.ROOF_SIGN_FORM_CONTROL_NAME;
    skySignControlName = ViewApplicationDetailsAamsConstants.SKY_SIGN_FORM_CONTROL_NAME;
    verandaControlName = ViewApplicationDetailsAamsConstants.VERANDA_FORM_CONTROL_NAME;
    aerialSignControlName = ViewApplicationDetailsAamsConstants.AERIAL_SIGN_FORM_CONTROL_NAME;
    windowSignControlName = ViewApplicationDetailsAamsConstants.WINDOW_SIGN_FORM_CONTROL_NAME;
    schoolSignControlName = ViewApplicationDetailsAamsConstants.SCHOOL_SIGN_FORM_CONTROL_NAME;
    combinationSignControlName = ViewApplicationDetailsAamsConstants.COMBINATION_SIGN_FORM_CONTROL_NAME;
    underAwningSignControlName = ViewApplicationDetailsAamsConstants.UNDER_AWNING_SIGN_FORM_CONTROL_NAME;
    flagSignControlName = ViewApplicationDetailsAamsConstants.FLAG_SIGN_FORM_CONTROL_NAME;
    canopyControlName = ViewApplicationDetailsAamsConstants.CANOPY_FORM_CONTROL_NAME;
    balconyControlName = ViewApplicationDetailsAamsConstants.BALCONY_FORM_CONTROL_NAME;
    electronicSignControlName = ViewApplicationDetailsAamsConstants.ELECTRONIC_SIGN_FORM_CONTROL_NAME;
    developmentBoardControlName = ViewApplicationDetailsAamsConstants.DEVELOPMENT_BOARD_FORM_CONTROL_NAME;
    otherFiveYearControlName = ViewApplicationDetailsAamsConstants.OTHER_FIVE_YEAR_FORM_CONTROL_NAME;
    nonIlluminatedBillboardControlName = ViewApplicationDetailsAamsConstants.NON_ILLUMINATED_BILLBOARD_FORM_CONTROL_NAME;
    digitalBillboardControlName = ViewApplicationDetailsAamsConstants.DIGITAL_BILLBOARD_FORM_CONTROL_NAME;
    nonIlluminatedGantryControlName = ViewApplicationDetailsAamsConstants.NON_ILLUMINATED_GANTRY_FORM_CONTROL_NAME;
    digitalGantryControlName = ViewApplicationDetailsAamsConstants.DIGITAL_GANTRY_FORM_CONTROL_NAME;
    internallyIlluminatedBillboardControlName = ViewApplicationDetailsAamsConstants.INTERNALLY_ILLUMINATED_BILLBOARD_FORM_CONTROL_NAME;
    internallyIlluminatedGantryControlName = ViewApplicationDetailsAamsConstants.INTERNALLY_ILLUMINATED_GANTRY_FORM_CONTROL_NAME;
    municipalConsumerAccountNumberFormControlName = ViewApplicationDetailsAamsConstants.MUNICIPAL_CONSUMER_ACCOUNT_NUMBER_CONTROL_NAME;
    personResponsibleFormControlName = ViewApplicationDetailsAamsConstants.PERSON_RESPONSIBLE_CONTROL_NAME;
    // Labels
    descriptionLabel = ViewApplicationDetailsAamsConstants.DESCRIPTION_LABEL;
    isAdvertisementPermanentOrTemporaryFormLabel = ViewApplicationDetailsAamsConstants.IS_ADVERTISEMENT_PERMANENT_OR_TEMPORARY_LABEL;
    typeLabel = ViewApplicationDetailsAamsConstants.APPLICATION_TYPE_LABEL;
    displayStartDateLabel = ViewApplicationDetailsAamsConstants.DISPLAY_START_DATE_LABEL;
    displayEndDateLabel = ViewApplicationDetailsAamsConstants.DISPLAY_END_DATE_LABEL;
    displayRemovalDateLabel = ViewApplicationDetailsAamsConstants.DISPLAY_REMOVAL_DATE_LABEL;
    numberOfPostersLabel = ViewApplicationDetailsAamsConstants.NUMBER_OF_POSTERS_LABEL;
    nameOfBusinessLabel = ViewApplicationDetailsAamsConstants.NAME_OF_BUSINESS_LABEL;
    notifySignageRemovalPeriodLabel = ViewApplicationDetailsAamsConstants.NOTIFY_SIGNAGE_REMOVAL_LABEL;
    positionOfTheDisplayLabel = ViewApplicationDetailsAamsConstants.POSITION_OF_THE_DISPLAY_LABEL;
    heightLabel = ViewApplicationDetailsAamsConstants.HEIGHT_LABEL;
    widthLabel = ViewApplicationDetailsAamsConstants.WIDTH_LABEL;
    depthLabel = ViewApplicationDetailsAamsConstants.DEPTH_LABEL;
    materialLabel = ViewApplicationDetailsAamsConstants.MATERIAL_LABEL;
    coloursLabel = ViewApplicationDetailsAamsConstants.COLOURS_LABEL;
    frontalAreaLabel = ViewApplicationDetailsAamsConstants.FRONTAL_AREA_LABEL;
    totalAreaLabel = ViewApplicationDetailsAamsConstants.TOTAL_AREA_LABEL;
    signTypeLabel = ViewApplicationDetailsAamsConstants.SIGN_TYPE_LABEL;
    weightLabel = ViewApplicationDetailsAamsConstants.WEIGHT_LABEL;
    wattageLabel = ViewApplicationDetailsAamsConstants.WATTAGE_LABEL;
    signContractorLabel = ViewApplicationDetailsAamsConstants.SIGN_CONTRACTOR_LABEL;
    signContractorAddressLabel = ViewApplicationDetailsAamsConstants.SIGN_CONTRACTOR_ADDRESS_LABEL;
    signContractorTelephoneLabel = ViewApplicationDetailsAamsConstants.SIGN_CONTRACTOR_TELEPHONE_LABEL;
    forSaleAddressLabel = ViewApplicationDetailsAamsConstants.FOR_SALE_LABEL;
    // 1 year permanent
    onShowLabel = ViewApplicationDetailsAamsConstants.ON_SHOW_LABEL;
    toLetLabel = ViewApplicationDetailsAamsConstants.TO_LET_LABEL;
    soldLabel = ViewApplicationDetailsAamsConstants.SOLD_LABEL;
    constructionBoardSignLabel = ViewApplicationDetailsAamsConstants.CONSTRUCTION_BOARD_SIGN_LABEL;
    otherLabel = ViewApplicationDetailsAamsConstants.OTHER_LABEL;
    // 5 year permanent
    groundSignLabel = ViewApplicationDetailsAamsConstants.GROUND_SIGN_FORM_LABEL;
    flagLabel = ViewApplicationDetailsAamsConstants.FLAG_FORM_LABEL;
    sandwichBoardLabel = ViewApplicationDetailsAamsConstants.SANDWICH_BOARD_FORM_LABEL;
    pylonLabel = ViewApplicationDetailsAamsConstants.PYLON_FORM_LABEL;
    wallSignLabel = ViewApplicationDetailsAamsConstants.WALL_SIGN_FORM_LABEL;
    billBoardLabel = ViewApplicationDetailsAamsConstants.BILLBOARD_FORM_LABEL;
    buildingAttachmentLabel = ViewApplicationDetailsAamsConstants.BUILDING_ATTACHMENT_LABEL;
    projectingWallLabel = ViewApplicationDetailsAamsConstants.PROJECTING_WALL_SIGN_LABEL;
    wallPaintedLabel = ViewApplicationDetailsAamsConstants.WALL_PAINTED_LABEL;
    roofSignLabel = ViewApplicationDetailsAamsConstants.ROOF_SIGN_LABEL;
    skySignLabel = ViewApplicationDetailsAamsConstants.SKY_SIGN_LABEL;
    verandaLabel = ViewApplicationDetailsAamsConstants.VERANDA_LABEL;
    aerialSignLabel = ViewApplicationDetailsAamsConstants.AERIAL_SIGN_LABEL;
    windowSignLabel = ViewApplicationDetailsAamsConstants.WINDOW_SIGN_LABEL;
    schoolSignLabel = ViewApplicationDetailsAamsConstants.SCHOOL_SIGN_LABEL;
    combinationSignLabel = ViewApplicationDetailsAamsConstants.COMBINATION_SIGN_LABEL;
    underAwningSignLabel = ViewApplicationDetailsAamsConstants.UNDER_AWNING_SIGN_LABEL;
    flagSignLabel = ViewApplicationDetailsAamsConstants.FLAG_SIGN_LABEL;
    canopyLabel = ViewApplicationDetailsAamsConstants.CANOPY_LABEL;
    balconyLabel = ViewApplicationDetailsAamsConstants.BALCONY_LABEL;
    electronicSignLabel = ViewApplicationDetailsAamsConstants.ELECTRONIC_SIGN_LABEL;
    developmentBoardLabel = ViewApplicationDetailsAamsConstants.DEVELOPMENT_BOARD_LABEL;
    otherFiveYearLabel = ViewApplicationDetailsAamsConstants.OTHER_FIVE_YEAR_LABEL;
    nonIlluminatedBillboardLabel = ViewApplicationDetailsAamsConstants.NON_ILLUMINATED_BILLBOARD_LABEL;
    digitalBillboardLabel = ViewApplicationDetailsAamsConstants.DIGITAL_BILLBOARD_LABEL;
    nonIlluminatedGantryLabel = ViewApplicationDetailsAamsConstants.NON_ILLUMINATED_GANTRY_LABEL;
    digitalGantryLabel = ViewApplicationDetailsAamsConstants.DIGITAL_GANTRY_LABEL;
    internallyIlluminatedBillboardLabel = ViewApplicationDetailsAamsConstants.INTERNALLY_ILLUMINATED_BILLBOARD_LABEL;
    internallyIlluminatedGantryLabel = ViewApplicationDetailsAamsConstants.INTERNALLY_ILLUMINATED_GANTRY_LABEL;
    removeLabel = SharedConstants.REMOVE_LABEL;
    municipalConsumerAccountNumberLabel = ViewApplicationDetailsAamsConstants.MUNICIPAL_CONSUMER_ACCOUNT_NUMBER_LABEL;
    personResponsibleLabel = ViewApplicationDetailsAamsConstants.PERSON_RESPONSIBLE_CONTROL_LABEL;
    // Lookups
    applicationTypesLookups = [];
    permanentOrTemporaryLookupOptions = LookupConstants.PERMANENT_OR_TEMPORARY_LOOKUPS_A;
    signTypeLookups = [];
    removalPeriodLookups = LookupConstants.REMOVAL_PERIOD_LOOKUPS_A;
    nonIlluminatedBillboardLookups = LookupConstants.NON_ILLUMINATED_BILLBOARD_A;
    nonIlluminatedGantryLookups = LookupConstants.NON_ILLUMINATED_GANTRY_A;
    internallyIlluminatedBillboardLookups = LookupConstants.INTERNALLY_ILLUMINATED_BILLBOARD_LOOKUPS_A;
    digitalGantryLookups = LookupConstants.DIGITAL_GANTRY_A;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    showTemporaryApplicationFields = false;
    showPermanentApplicationFields = false;
    show5YearPermanentApplicationOptionalFields = false;
    show1YearPermanentApplicationOptionalFields = false;
    // person responsible recipient
    personResponsibleDisableAdd = true;
    personResponsibleDisableEditing = true;
    personResponsibleDisableFilterBy = true;
    personResponsibleIsInternal = false;
    personResponsibleGroups = [];
    personResponsibleShowFields = true;
    application;
    referenceNumberControlName = ViewApplicationDetailsAamsConstants.REFERENCE_NUMBER_CONTROL_NAME;
    referenceNumberLabel = ViewApplicationDetailsAamsConstants.REFERENCE_NUMBER_LABEL;
    getLookupsObservableSubscription;
    getStepMetaObservableSubscription;
    getApplicationObservableSubscription;
    constructor(aflaModuleStrategyService, viewApplicationService, route, recipientSelectService, datePipe, routerParamsService, appControllerService, changeDetectorRefs) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.viewApplicationService = viewApplicationService;
        this.route = route;
        this.recipientSelectService = recipientSelectService;
        this.datePipe = datePipe;
        this.routerParamsService = routerParamsService;
        this.appControllerService = appControllerService;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.listenForRouteParamChange();
        this.initForm();
        this.getLookups();
    }
    getApplication() {
        const params = {
            $filter: `jobId eq ${this.jobID}`,
            $expand: `personResponsible,point,polygon`
        };
        this.getApplicationObservableSubscription = this.viewApplicationService
            .getApplicationObservable(this.aflaModuleStrategyService.applicationServiceUrl, params)
            .subscribe({
            next: (response) => {
                this.onGetApplicationCompleted(response);
            },
            error: (error) => {
                this.appControllerService.handleServerErrorMessage(ViewApplicationDetailsAamsConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    loadMetadata(stepMeta) {
        try {
            if (!this.appControllerService.moduleSimulateMode) {
                this.personResponsibleGroups = this.recipientSelectService.checkStepMetaRecipientGroups(stepMeta.personResponsibleGroup);
            }
            this.changeDetectorRefs.detectChanges();
        }
        catch (e) {
            this.appControllerService.showMessage(SharedConstants.INVALID_METADATA, AlertType.Error);
        }
    }
    setCommonFormFields(application) {
        this.detailsForm.get(this.referenceNumberControlName).setValue(application.referenceNumber);
        this.detailsForm.get(this.descriptionFormControlName).setValue(application.description);
        this.detailsForm.get(this.descriptionFormControlName).disable();
        this.detailsForm.get(this.isAdvertisementPermanentOrTemporaryFormControlName).setValue(application.isAdvetisingPermanentOrTemporary);
        this.detailsForm.get(this.isAdvertisementPermanentOrTemporaryFormControlName).disable();
        this.detailsForm.get(this.applicationTypeFormControlName).setValue(application.type);
        this.detailsForm.get(this.applicationTypeFormControlName).disable();
        this.detailsForm.updateValueAndValidity();
    }
    handleRouteChange() {
        this.initialiseForm();
    }
    onGetApplicationCompleted(response) {
        if (response && response.value.length > 0) {
            this.detailsForm.reset();
            const application = response.value[0];
            this.application = application;
            this.setFormControls(application);
        }
    }
    setFormControls(application) {
        const advertisementType = application.isAdvetisingPermanentOrTemporary;
        if (advertisementType?.toLowerCase() === "temporary") {
            this.hide1YearPermanentApplicationFields();
            this.hide5YearPermanentApplicationFields();
            this.hideMainPermanentFields();
            this.showTemporaryApplicationTypeFields();
            this.setTemporaryFieldsValues(application);
        }
        if (advertisementType?.toLowerCase() === "permanent") {
            this.hideTemporaryApplicationTypeFields();
            this.showPermanentAdvertisementFields();
            this.setMainPermanentFieldsValues(application);
            if (application.type.toLowerCase().includes("1 year")) {
                this.reset5YearPermanentApplicationFields();
                this.hide5YearPermanentApplicationFields();
                this.show1YearPermanentApplicationFields();
                this.set1yearPermanentFieldsValues(application);
            }
            if (application.type.toLowerCase().includes("5 year")) {
                this.reset1yearPermanentApplicationFields();
                this.hide1YearPermanentApplicationFields();
                this.show5YearPermanentApplicationFields();
                this.set5YearPermanentApplicationFields(application);
            }
        }
        this.setCommonFormFields(application);
        this.changeDetectorRefs.detectChanges();
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.appControllerService.selectedModuleID} and deleted eq false`,
        };
        this.getLookupsObservableSubscription = this.viewApplicationService.getLookupsObservable(params).subscribe({
            next: (response) => {
                const lookups = response.value;
                if (lookups.length > 0) {
                    this.getLookupCompleted(lookups);
                }
            }, error: (error) => {
                this.appControllerService.handleServerErrorMessage(ViewApplicationDetailsAamsConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    getLookupCompleted(lookups) {
        lookups.forEach((lookUp) => {
            if (lookUp.name?.toLowerCase()?.trim() === "applicationtype") {
                const lookUpContent = JSON.parse(lookUp.content);
                this.applicationTypesLookups.push(lookUpContent);
            }
            if (lookUp.name?.toLowerCase()?.trim() === "signtype") {
                const lookUpContent = JSON.parse(lookUp.content);
                this.signTypeLookups.push(lookUpContent);
            }
        });
        this.getApplication();
        this.changeDetectorRefs.detectChanges();
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get(this.applicationDetailsFormGroupName);
    }
    showTemporaryApplicationTypeFields() {
        this.showTemporaryApplicationFields = true;
    }
    hideTemporaryApplicationTypeFields() {
        this.showTemporaryApplicationFields = false;
    }
    showPermanentAdvertisementFields() {
        this.showPermanentApplicationFields = true;
    }
    reset5YearPermanentApplicationFields() {
        this.detailsForm.get(this.groundSignControlName).reset(false);
        this.detailsForm.get(this.flagControlName).reset(false);
        this.detailsForm.get(this.sandwichBoardControlName).reset(false);
        this.detailsForm.get(this.pylonControlName).reset(false);
        this.detailsForm.get(this.wallSignControlName).reset(false);
        this.detailsForm.get(this.billBoardControlName).reset(false);
        this.detailsForm.get(this.buildingAttachmentControlName).reset(false);
        this.detailsForm.get(this.projectingWallControlName).reset(false);
        this.detailsForm.get(this.wallPaintedControlName).reset(false);
        this.detailsForm.get(this.roofSignControlName).reset(false);
        this.detailsForm.get(this.skySignControlName).reset(false);
        this.detailsForm.get(this.verandaControlName).reset(false);
        this.detailsForm.get(this.aerialSignControlName).reset(false);
        this.detailsForm.get(this.windowSignControlName).reset(false);
        this.detailsForm.get(this.schoolSignControlName).reset(false);
        this.detailsForm.get(this.combinationSignControlName).reset(false);
        this.detailsForm.get(this.underAwningSignControlName).reset(false);
        this.detailsForm.get(this.flagSignControlName).reset(false);
        this.detailsForm.get(this.canopyControlName).reset(false);
        this.detailsForm.get(this.balconyControlName).reset(false);
        this.detailsForm.get(this.electronicSignControlName).reset(false);
        this.detailsForm.get(this.developmentBoardControlName).reset(false);
        this.detailsForm.get(this.otherFiveYearControlName).reset();
        this.detailsForm.get(this.nonIlluminatedBillboardControlName).reset();
        this.detailsForm.get(this.digitalBillboardControlName).reset();
        this.detailsForm.get(this.nonIlluminatedGantryControlName).reset();
        this.detailsForm.get(this.digitalGantryControlName).reset();
        this.detailsForm.get(this.internallyIlluminatedBillboardControlName).reset();
        this.detailsForm.get(this.internallyIlluminatedGantryControlName).reset();
        this.detailsForm.updateValueAndValidity();
    }
    reset1yearPermanentApplicationFields() {
        this.detailsForm.get(this.forSaleControlName).reset(false);
        this.detailsForm.get(this.onShowControlName).reset(false);
        this.detailsForm.get(this.toLetControlName).reset(false);
        this.detailsForm.get(this.soldControlName).reset(false);
        this.detailsForm.get(this.constructionBoardSignControlName).reset(false);
        this.detailsForm.get(this.OtherControlName).reset();
        this.detailsForm.updateValueAndValidity();
    }
    setTemporaryFieldsValues(application) {
        this.detailsForm.get(this.displayStartDateControlName).setValue(this.datePipe.transform(application.displayStartDate, "yyyy-MM-dd"));
        this.detailsForm.get(this.displayStartDateControlName).disable();
        this.detailsForm.get(this.displayEndDateControlName).setValue(this.datePipe.transform(application.displayEndDate, "yyyy-MM-dd"));
        this.detailsForm.get(this.displayEndDateControlName).disable();
        this.detailsForm.get(this.displayRemovalDateControlName).setValue(this.datePipe.transform(application.displayRemovalDate, "yyyy-MM-dd"));
        this.detailsForm.get(this.displayRemovalDateControlName).disable();
        this.detailsForm.get(this.numberOfPostersControlName).setValue(application.numberOfPosters);
        this.detailsForm.get(this.numberOfPostersControlName).disable();
        this.detailsForm.updateValueAndValidity();
    }
    setMainPermanentFieldsValues(application) {
        this.detailsForm.get(this.nameOfBusinessControlName).setValue(application.nameOfBusiness);
        this.detailsForm.get(this.nameOfBusinessControlName).disable();
        this.detailsForm.get(this.notifySignageRemovalPeriodControlName).setValue(application.notifySignageRemovalPeriod);
        this.detailsForm.get(this.notifySignageRemovalPeriodControlName).disable();
        this.detailsForm.get(this.positionOfTheDisplayControlName).setValue(application.positionOfDisplay);
        this.detailsForm.get(this.positionOfTheDisplayControlName).disable();
        this.detailsForm.get(this.heightControlName).setValue(application.dimensionsH);
        this.detailsForm.get(this.heightControlName).disable();
        this.detailsForm.get(this.widthControlName).setValue(application.dimensionsW);
        this.detailsForm.get(this.widthControlName).disable();
        this.detailsForm.get(this.depthControlName).setValue(application.dimensionsD);
        this.detailsForm.get(this.depthControlName).disable();
        this.detailsForm.get(this.materialControlName).setValue(application.material);
        this.detailsForm.get(this.materialControlName).disable();
        this.detailsForm.get(this.coloursControlName).setValue(application.colours);
        this.detailsForm.get(this.coloursControlName).disable();
        this.detailsForm.get(this.frontalAreaControlName).setValue(application.frontalArea);
        this.detailsForm.get(this.frontalAreaControlName).disable();
        this.detailsForm.get(this.totalAreaControlName).setValue(application.totalArea);
        this.detailsForm.get(this.totalAreaControlName).disable();
        this.detailsForm.get(this.signTypeControlName).setValue(application.signType);
        this.detailsForm.get(this.signTypeControlName).disable();
        this.detailsForm.get(this.weightControlName).setValue(application.weight);
        this.detailsForm.get(this.weightControlName).disable();
        this.detailsForm.get(this.wattageControlName).setValue(application.wattage);
        this.detailsForm.get(this.wattageControlName).disable();
        this.detailsForm.get(this.signContractorControlName).setValue(application.contractorName);
        this.detailsForm.get(this.signContractorControlName).disable();
        this.detailsForm.get(this.signContractorAddressControlName).setValue(application.contractorAddress);
        this.detailsForm.get(this.signContractorAddressControlName).disable();
        this.detailsForm.get(this.signContractorTelephoneControlName).setValue(application.contractorTelephone);
        this.detailsForm.get(this.signContractorTelephoneControlName).disable();
        this.detailsForm.get(this.municipalConsumerAccountNumberFormControlName).setValue(application.municipalConsumerAccountNumber);
        this.detailsForm.get(this.municipalConsumerAccountNumberFormControlName).disable();
        this.detailsForm.updateValueAndValidity();
    }
    set1yearPermanentFieldsValues(application) {
        const personResponsibleControl = this.detailsForm.get(this.personResponsibleFormControlName);
        this.detailsForm.get(this.forSaleControlName).setValue(application.forSale);
        this.detailsForm.get(this.forSaleControlName).disable();
        this.detailsForm.get(this.onShowControlName).setValue(application.onShow);
        this.detailsForm.get(this.onShowControlName).disable();
        this.detailsForm.get(this.toLetControlName).setValue(application.toLet);
        this.detailsForm.get(this.toLetControlName).disable();
        this.detailsForm.get(this.soldControlName).setValue(application.sold);
        this.detailsForm.get(this.soldControlName).disable();
        this.detailsForm.get(this.constructionBoardSignControlName).setValue(application.constructionBoardSign);
        this.detailsForm.get(this.constructionBoardSignControlName).disable();
        this.detailsForm.get(this.OtherControlName).setValue(application.otherOneYear);
        this.detailsForm.get(this.OtherControlName).disable();
        this.detailsForm.get(this.municipalConsumerAccountNumberFormControlName).setValue(application.otherOneYear);
        this.detailsForm.get(this.municipalConsumerAccountNumberFormControlName).disable();
        this.recipientSelectService.setRecipient(application.personResponsible[0], false, personResponsibleControl);
        personResponsibleControl.disable();
        this.detailsForm.updateValueAndValidity();
    }
    set5YearPermanentApplicationFields(application) {
        const personResponsibleControl = this.detailsForm.get(this.personResponsibleFormControlName);
        this.detailsForm.get(this.groundSignControlName).setValue(application.groundSign);
        this.detailsForm.get(this.groundSignControlName).disable();
        this.detailsForm.get(this.flagControlName).setValue(application.flag);
        this.detailsForm.get(this.flagControlName).disable();
        this.detailsForm.get(this.sandwichBoardControlName).setValue(application.sandwichBoard);
        this.detailsForm.get(this.sandwichBoardControlName).disable();
        this.detailsForm.get(this.pylonControlName).setValue(application.pylon);
        this.detailsForm.get(this.pylonControlName).disable();
        this.detailsForm.get(this.wallSignControlName).setValue(application.wallSign);
        this.detailsForm.get(this.wallSignControlName).disable();
        this.detailsForm.get(this.billBoardControlName).setValue(application.billboard);
        this.detailsForm.get(this.billBoardControlName).disable();
        this.detailsForm.get(this.buildingAttachmentControlName).setValue(application.buildingAttachment);
        this.detailsForm.get(this.buildingAttachmentControlName).disable();
        this.detailsForm.get(this.projectingWallControlName).setValue(application.projectingWallSign);
        this.detailsForm.get(this.projectingWallControlName).disable();
        this.detailsForm.get(this.wallPaintedControlName).setValue(application.wallPainted);
        this.detailsForm.get(this.wallPaintedControlName).disable();
        this.detailsForm.get(this.roofSignControlName).setValue(application.roofSign);
        this.detailsForm.get(this.roofSignControlName).disable();
        this.detailsForm.get(this.skySignControlName).setValue(application.skySign);
        this.detailsForm.get(this.skySignControlName).disable();
        this.detailsForm.get(this.verandaControlName).setValue(application.veranda);
        this.detailsForm.get(this.verandaControlName).disable();
        this.detailsForm.get(this.aerialSignControlName).setValue(application.aerialSign);
        this.detailsForm.get(this.aerialSignControlName).disable();
        this.detailsForm.get(this.windowSignControlName).setValue(application.windowSign);
        this.detailsForm.get(this.windowSignControlName).disable();
        this.detailsForm.get(this.schoolSignControlName).setValue(application.schoolSign);
        this.detailsForm.get(this.schoolSignControlName).disable();
        this.detailsForm.get(this.combinationSignControlName).setValue(application.combinationSign);
        this.detailsForm.get(this.combinationSignControlName).disable();
        this.detailsForm.get(this.underAwningSignControlName).setValue(application.underAwningSign);
        this.detailsForm.get(this.underAwningSignControlName).disable();
        this.detailsForm.get(this.flagSignControlName).setValue(application.flagSign);
        this.detailsForm.get(this.flagSignControlName).disable();
        this.detailsForm.get(this.canopyControlName).setValue(application.canopy);
        this.detailsForm.get(this.canopyControlName).disable();
        this.detailsForm.get(this.balconyControlName).setValue(application.balcony);
        this.detailsForm.get(this.balconyControlName).disable();
        this.detailsForm.get(this.electronicSignControlName).setValue(application.electronicSign);
        this.detailsForm.get(this.electronicSignControlName).disable();
        this.detailsForm.get(this.developmentBoardControlName).setValue(application.developmentBoard);
        this.detailsForm.get(this.developmentBoardControlName).disable();
        this.detailsForm.get(this.otherFiveYearControlName).setValue(application.otherFiveYear);
        this.detailsForm.get(this.otherFiveYearControlName).disable();
        this.detailsForm.get(this.nonIlluminatedBillboardControlName).setValue(application.nonIlluminatedBillboard);
        this.detailsForm.get(this.nonIlluminatedBillboardControlName).disable();
        this.detailsForm.get(this.digitalBillboardControlName).setValue(application.digitalBillboard);
        this.detailsForm.get(this.digitalBillboardControlName).disable();
        this.detailsForm.get(this.nonIlluminatedGantryControlName).setValue(application.nonIlluminatedGantry);
        this.detailsForm.get(this.nonIlluminatedGantryControlName).disable();
        this.detailsForm.get(this.digitalGantryControlName).setValue(application.digitalGantry);
        this.detailsForm.get(this.digitalGantryControlName).disable();
        this.detailsForm.get(this.internallyIlluminatedBillboardControlName).setValue(application.internallyIlluminatedBillboard);
        this.detailsForm.get(this.internallyIlluminatedBillboardControlName).disable();
        this.detailsForm.get(this.internallyIlluminatedGantryControlName).setValue(application.internallyIlluminatedGantry);
        this.detailsForm.get(this.internallyIlluminatedGantryControlName).disable();
        this.detailsForm.get(this.municipalConsumerAccountNumberFormControlName).setValue(application.municipalConsumerAccountNumber);
        this.detailsForm.get(this.municipalConsumerAccountNumberFormControlName).disable();
        this.recipientSelectService.setRecipient(application.personResponsible[0], false, personResponsibleControl);
        personResponsibleControl.disable();
        this.detailsForm.updateValueAndValidity();
    }
    initialiseForm() {
        const filterString = `stepName eq \'Start\' AND moduleId eq ${this.moduleID}`;
        const params = {
            $filter: filterString
        };
        this.getStepMetaObservableSubscription = this.viewApplicationService.getStepMetaObservable(params).subscribe((metadata) => {
            this.loadMetadata(JSON.parse(metadata.value[0].metadata));
        });
    }
    hide1YearPermanentApplicationFields() {
        this.show1YearPermanentApplicationOptionalFields = false;
    }
    hide5YearPermanentApplicationFields() {
        this.show5YearPermanentApplicationOptionalFields = false;
    }
    hideMainPermanentFields() {
        this.showPermanentApplicationFields = false;
    }
    show1YearPermanentApplicationFields() {
        this.show1YearPermanentApplicationOptionalFields = true;
    }
    show5YearPermanentApplicationFields() {
        this.show5YearPermanentApplicationOptionalFields = true;
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: ViewApplicationService },
        { type: ActivatedRoute },
        { type: RecipientSelectService },
        { type: DatePipe },
        { type: RouterParamsService },
        { type: AppControllerService },
        { type: ChangeDetectorRef }
    ];
};
ViewApplicationDetailsAamsComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-view-application-details-aams",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationDetailsAamsComponent);
export { ViewApplicationDetailsAamsComponent };
